import { HttpMethodEnum, QuestelServicesClient, RequestResult } from '@questelservices/common';
import store from '../store';
import { LoadOptions } from 'devextreme/data/load_options';
import { MatterWorkTypeEnum } from '@/models/matter-work/MatterWorkTypeEnum';
import { BatchTypeEnum } from '@/models/batch/BatchTypeEnum';

export class ActivityPlannerService {
    private client: QuestelServicesClient;

    constructor(baseUrl: string) {
        this.client = new QuestelServicesClient(store, `${baseUrl}/activityplanner`);
    }

    public getAvailableWork(options: LoadOptions, matterWorkType: MatterWorkTypeEnum, batchType: BatchTypeEnum) {
        return this.client.getPostData(`/work/${matterWorkType}/${batchType}`, options);
    }

    public claimWork(workToClaim: object, matterWorkType: MatterWorkTypeEnum): Promise<RequestResult> {
        return this.client.postJson(`/claim-matters/${matterWorkType}`, workToClaim);
    }

    public async clientSummary(options: LoadOptions): Promise<any> {
        return await this.client.getPostData(`/client-summary`, options);
    }

    public async getAnalysisTexts(clientId: Guid, batchId: Guid) {
        return await this.client.getData(HttpMethodEnum.Get, `/analysis-text-review/${clientId}/${batchId}`);
    }
}